import { array, literal, object, string, union, z } from "zod";

import { LadyMinV2DTO, LadyMinV2DTORaw } from "@/models/lady-dtos";

export const LastContactsResponseDTOError = object({
  requestDTO: object({
    dataMap: object({
      error: string(),
    }),
  }),
});

export const LastContactsResponseDTOSuccessRaw = object({
  requestDTO: object({
    processorClass: literal("GetLastContacts"),
    dataMap: object({
      result: array(LadyMinV2DTORaw),
      actualDate: string(),
    }),
  }),
});

export const lastContacts = (response: LastContactsResponseDTORaw) =>
  LastContactsResponseDTOSuccessRaw.safeParse(response);

export type LastContactsResponseDTOSuccess = z.infer<
  typeof LastContactsResponseDTOSuccessRaw
>;

export type LastContactsResponseDTOError = z.infer<
  typeof LastContactsResponseDTOError
>;

export const LastContactsResponseDTORaw = union([
  LastContactsResponseDTOError,
  LastContactsResponseDTOSuccessRaw,
]);

export type LastContactsResponseDTORaw = z.infer<
  typeof LastContactsResponseDTORaw
>;
export const LastContactsResponseDTOSuccess = object({
  requestDTO: object({
    processorClass: literal("GetLastContacts"),
    dataMap: object({
      result: array(LadyMinV2DTO),
      actualDate: string(),
    }),
  }),
});
export const LastContactsResponseDTO = union([
  LastContactsResponseDTOError,
  LastContactsResponseDTOSuccess,
]);
export type LastContactsResponseDTO = z.infer<typeof LastContactsResponseDTO>;
